
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy/multi-state-privacy-policy",
      function () {
        return require("private-next-pages/privacy/multi-state-privacy-policy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy/multi-state-privacy-policy"])
      });
    }
  